import CoursesTaughtModule from './containers/coursesTaughtModule'

export {default as CoursesTaughtModuleLayout} from './components/coursesTaughtModuleLayout'

export default CoursesTaughtModule
